/**
 * Redux Store Configuration for Rider Gateway (Mobile)
 * Mobile-optimized store with offline persistence
 */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import scooterReducer from './slices/scooterSlice';
import walletReducer from './slices/walletSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    scooter: scooterReducer,
    wallet: walletReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization checks
        ignoredActions: [
          'auth/initializeAuth/fulfilled',
          'auth/handleAuthCallback/fulfilled',
          'auth/refreshTokens/fulfilled',
          'auth/updateNetworkStatus/fulfilled',
          'scooter/switchToScooter/fulfilled',
          'scooter/refreshCurrentScooterData/fulfilled',
          'wallet/fetchWalletBalance/fulfilled',
        ],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.details'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.error.details'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;